import React, { Fragment } from 'react'
import Link from 'gatsby-link'
import styled from "react-emotion"
import Img from "gatsby-image";
import ImageContainer from "../components/common/ImageContainer";
import PageTitle from "../components/common/PageTitle";

const PageBody = styled.div`
  color: #ffffff;
  width: 90%;
  align-self: center;

  @media (min-width: 960px) {
    & {
      width: 54%;
    }
    & p {
      font-size: 1.2rem;
      line-height: 1.5;
      margin-bottom: 1.2rem;
    }
  }
`

const linkStyle = { 
  textDecoration: "none", 
  color: "#222", 
  backgroundColor: "#e3cf34",
  padding: 10,
  borderRadius: 10,
  display:"inline-block",
}


const ChapterComponent = (props) => {
  const { data: { chapter, page } } = props;
  return (
    <div className="gradient-bg" css={{ flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
      {chapter ?
        <ImageContainer>
          <Img resolutions={chapter.background.resolutions} />
        </ImageContainer>
      : null }
      {chapter ? <PageTitle>{chapter.title}</PageTitle> : null }
      {chapter ? <PageBody dangerouslySetInnerHTML={{ __html: chapter.subtitle.childMarkdownRemark.html }} /> : null }
      {chapter ?
        <div css={{
          textAlign: "center",
        }}>
          <Link to={`/${chapter.slug}/${page.path}/`} css={linkStyle}>Next Page <i className="icon-276" css={{fontSize: ".7em" }} /></Link>
        </div>
      : null }
    </div>
  )
}

export default ChapterComponent;

export const pageQuery = graphql`
query ChapterQuery($id: String!, $firstPage: String) {
  chapter: contentfulChapter(id:{ eq: $id }) {
    title
    slug
    subtitle {
      childMarkdownRemark {
        html
      }
    }
    background {
      resolutions(width: 1920, height: 1080, quality: 50) {
        src
      } 
    }
  }
  page: contentfulPage(id: { eq: $firstPage }) {
    path
    title
  }
}
`


// WEBPACK FOOTER //
// ./src/components/chapter.js